<div class="flex flex-row items-center gap-1 shrink-0">
  <!-- Tooltip am Wrapper: bic-button (2.0.4) nimmt `title` zwar als Input an, rendert es aber nicht
       ins <button>; deshalb die tooltip-Direktive wie in der übrigen App. -->
  <span [tooltip]="acceptLabel" class="inline-flex" data-proposal-action="accept" tooltipDirection="top">
    <bic-button (onClick)="acceptClicked.emit()" [ariaLabel]="acceptLabel" [iconOnly]="true" buttonType="white">
      <fa-icon [icon]="faCheck" class="text-green-500"></fa-icon>
    </bic-button>
  </span>
  <span [tooltip]="rejectLabel" class="inline-flex" data-proposal-action="reject" tooltipDirection="top">
    <bic-button (onClick)="rejectClicked.emit()" [ariaLabel]="rejectLabel" [iconOnly]="true" buttonType="white">
      <fa-icon [icon]="faXmark" class="text-red-600"></fa-icon>
    </bic-button>
  </span>
</div>
